import { useState, FormEvent } from 'react';

export default function Kontakt() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telefon: '',
    eventdatum: '',
    gaeste: '',
    angebot: '',
    nachricht: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d63m105anburc340qhu0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          telefon: '',
          eventdatum: '',
          gaeste: '',
          angebot: '',
          nachricht: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="kontakt" className="py-32 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-6 tracking-tight">
            Kontaktieren Sie uns
          </h2>
          <p className="text-base md:text-lg text-gray-600 font-light max-w-2xl mx-auto leading-relaxed">
            Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden bei Ihnen
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
          <form id="kontakt-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-light text-gray-700 mb-2">
                  Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all"
                  placeholder="Ihr Name"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-light text-gray-700 mb-2">
                  E-Mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all"
                  placeholder="ihre@email.de"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="telefon" className="block text-sm font-light text-gray-700 mb-2">
                  Telefon
                </label>
                <input
                  type="tel"
                  id="telefon"
                  name="telefon"
                  value={formData.telefon}
                  onChange={(e) => setFormData({...formData, telefon: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all"
                  placeholder="+49 123 456789"
                />
              </div>
              <div>
                <label htmlFor="eventdatum" className="block text-sm font-light text-gray-700 mb-2">
                  Gewünschtes Eventdatum
                </label>
                <input
                  type="date"
                  id="eventdatum"
                  name="eventdatum"
                  value={formData.eventdatum}
                  onChange={(e) => setFormData({...formData, eventdatum: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="gaeste" className="block text-sm font-light text-gray-700 mb-2">
                  Anzahl der Gäste
                </label>
                <input
                  type="number"
                  id="gaeste"
                  name="gaeste"
                  min="1"
                  value={formData.gaeste}
                  onChange={(e) => setFormData({...formData, gaeste: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all"
                  placeholder="z.B. 50"
                />
              </div>
              <div>
                <label htmlFor="angebot" className="block text-sm font-light text-gray-700 mb-2">
                  Gewünschtes Angebot
                </label>
                <select
                  id="angebot"
                  name="angebot"
                  value={formData.angebot}
                  onChange={(e) => setFormData({...formData, angebot: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all cursor-pointer"
                >
                  <option value="">Bitte wählen</option>
                  <option value="klassisch">Die klassische Pasta-Bar</option>
                  <option value="livecooking">Das Highlight: Live-Cooking</option>
                  <option value="beide">Beide Angebote</option>
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="nachricht" className="block text-sm font-light text-gray-700 mb-2">
                Ihre Nachricht
              </label>
              <textarea
                id="nachricht"
                name="nachricht"
                rows={6}
                maxLength={500}
                value={formData.nachricht}
                onChange={(e) => setFormData({...formData, nachricht: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-600 focus:border-transparent text-sm transition-all resize-none"
                placeholder="Erzählen Sie uns mehr über Ihr Event... (max. 500 Zeichen)"
              ></textarea>
              <p className="text-xs text-gray-500 mt-1 font-light">
                {formData.nachricht.length}/500 Zeichen
              </p>
            </div>

            {submitStatus === 'success' && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-md">
                <p className="text-green-800 text-sm font-light">
                  Vielen Dank für Ihre Anfrage! Wir melden uns in Kürze bei Ihnen.
                </p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-md">
                <p className="text-red-800 text-sm font-light">
                  Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.
                </p>
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full px-8 py-4 bg-amber-600 text-white text-base font-light tracking-wide hover:bg-amber-700 transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
            >
              {isSubmitting ? 'Wird gesendet...' : 'Anfrage senden'}
            </button>
          </form>
        </div>

        {/* Impressum & Footer */}
        <footer className="mt-20 pt-12 border-t border-gray-200">
          <div className="mb-12">
            <h4 className="font-serif text-2xl text-gray-900 mb-6">
              <a href="#impressum" id="impressum" className="hover:text-amber-600 transition-colors cursor-pointer">Impressum</a>
            </h4>
            <div className="space-y-4 text-sm text-gray-600 font-light leading-relaxed">
              <p className="font-medium text-gray-800">Angaben gemäß §§ 5, 6 DDG</p>
              
              <div>
                <p className="font-medium text-gray-700 mb-1">Anbieter:</p>
                <p>Paula Schröter</p>
                <p>Laib und Liebe Catering</p>
                <p>Dobenaustraße 64</p>
                <p>08523 Plauen</p>
              </div>

              <div>
                <p className="font-medium text-gray-700 mb-1">Kontakt:</p>
                <p>Telefon: <a href="tel:015752379870" className="hover:text-amber-600 transition-colors cursor-pointer">015752379870</a></p>
                <p>E-Mail: <a href="mailto:laibundliebe-catering@freenet.de" className="hover:text-amber-600 transition-colors cursor-pointer">laibundliebe-catering@freenet.de</a></p>
              </div>

              <div>
                <p className="font-medium text-gray-700 mb-1">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</p>
                <p>Paula Schröter</p>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-200 text-center">
            <p className="text-sm text-gray-600 font-light">
              © 2025 Laib &amp; Liebe Catering. Alle Rechte vorbehalten.
            </p>
            <p className="text-sm text-gray-500 font-light mt-2">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-amber-600 transition-colors cursor-pointer">
                Website Builder
              </a>
            </p>
          </div>
        </footer>
      </div>
    </section>
  );
}
